import React, { Component, Fragment } from "react";
import { setLoader, setDeeplink } from "../../../../redux/actions";
import moment from "moment"
import {
  Row,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import CustomModal from "../../../../components/utils/CustomModal";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import _axios from "../../../../libs/axios";
import _moment from "../../../../libs/moment";
import { NotificationManager } from "../../../../components/common/react-notifications";
import FormCustom from "../../../../components/utils/FormCustom";
import Dialog from "../../../../components/utils/Dialog";
import { connect } from "react-redux";
import AppLocale from "../../../../config/lang";
import { getFileExtension } from "../../../../helpers/Utils"
import justificationReasons from '../../../../data/justificationReasons'
import { cloneDeep, debounce } from "lodash"

const defautltForm = {
  ID: null,
  attendanceTypeId: null,
  attendanceTypeName: null,
  comment: null,
  createdBy: null,
  createdByEmail: null,
  createdByName: null,
  createdByPhone: null,
  date: null,
  doc: null,
  docUrl: null,
  externalId: null,
  face: null,
  justification: null,
  last: null,
  last2: null,
  name: null,
  sectionTag: null,
  status: null,
  tillDate: null
}

let actions = {
  create: true,
  edit: true
}

const M = "admJustification."

class AdmJustification extends Component {
  constructor(props) {
    super(props);

    if (props.userAdmin.write.indexOf('admJustification') < 0) {
      actions.create = false
      actions.edit = false
    }

    this.state = {
      data: [],
      dataTemp: [],
      progressBar: false,
      form: defautltForm,
      formFilter: {
        status: 0,
        from: _moment().add(-6, 'days').format('YYYY-MM-DD'),
        to: _moment().format('YYYY-MM-DD'),
        search: ""
      },
      modal: false,
      modalDelete: false,
      idItemSelected: null,
      sessions: [],
      pupils: [],
      // upload files
      dropzones: [],
      uploadActive: -1,
      uploadFiles: null,
      actions: actions,
      preview: null
    };
  }

  UNSAFE_componentWillMount() {
    this.getData()
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
  }

  getData() {
    this.setState({ progressBar: true, data: [], dataTemp: [] })
    _axios
      .get('admJustification/get/?PageSize=10000&from=' + this.state.formFilter.from + '&to=' + this.state.formFilter.to + '&sectionId=' + this.state.formFilter.sectionId + '&superSectionId=' + this.state.formFilter.superSectionId + '&type=' + this.state.formFilter.type + (this.state.formFilter.justification?'&justification=' + this.state.formFilter.justification:'') + '&justify=' +  this.state.formFilter.status)
      .then(r => {
        if (r.status >= 0) {
          let temp = r.data.Results.filter(e => e.status === this.state.formFilter.status || this.state.formFilter.status === 0)
          this.setState({ data: r.data.Results, dataTemp: temp })
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.setState({ progressBar: false })
      })
  }

  getDataById(item) {
    this.props.setLoader(true)
    _axios
      .get('admJustification/get/' + item.ID)
      .then(r => {
        if (r.status >= 0) {
          if (r.data.doc && (r.data.doc.indexOf('.') === -1 || ['jpg','png','jpeg'].indexOf(getFileExtension(r.data.doc)) > -1)) {
            r.data.doc = r.data.doc+'.jpg'
            this.setState({preview: r.data.docUrl})
          }
          r.data.attendanceTypeId = r.data.attendanceTypeId === 0 ? null : { value: r.data.attendanceTypeId, label: r.data.attendanceTypeName }
          this.setState({ form: r.data, idItemSelected: item.ID }, () => {
            this.toggleModal(item)
          })
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.props.setLoader(false)
      })
  }

  create() {
    // console.log(this.state.form)
    this.validateForm().then(() => {
      let item = cloneDeep(this.state.form)
      console.log(item.doc)
      let body = {
        date: item.date + 'T00:00:00',
        file: item.doc && Array.isArray(item.doc) && item.doc.length > 0 ? item.doc[0].value : null, 
        note: item.comment,
        reason: item.justification,
        userId: item.userId,
        // sessionId: item.sessionId,
        fileType: item.doc && item.doc.length > 0 ? item.doc[0].ext : null,
        sessionId: 0,
        numOfDay: item.tillDate ? (_moment(item.tillDate).diff(item.date, 'days') + 1) : 1
      }
      // console.log(body)
      this.props.setLoader(true)
      _axios
        .post('attendance/absence', body)
        .then(r => {
          if (r.status >= 0) {
            this.toggleModal()
            this.getData()
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
          this.props.setLoader(false)
        })
    })
    .catch(e => { /* console.log(e) */ })
  }

  edit() {
    this.validateForm().then(() => {
      let item = cloneDeep(this.state.form)
      let body = {
        ID: item.ID,
        comment: item.comment,
        justification: item.justification,
        doc: Array.isArray(item.doc) ? (item.doc.length > 0 ? item.doc[0].name : null) : item.doc,
        attendanceTypeId: item.attendanceTypeId,
        tillDate: item.tillDate
      }
      // console.log(body)
      this.props.setLoader(true)
      _axios
        .post('admJustification/edit/' + this.state.idItemSelected, body)
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.uploadFiles(r.data).then((response) => {
              this.defaultValuesUploadFiles()
              if (r.msg) NotificationManager.success(r.msg, '', 4000, null, null, 'outline')
              this.toggleModal()
              this.getData()
            })
          } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  delete() {
    this.props.setLoader(true)
    _axios
      .post('admJustification/delete/' + this.state.idItemSelected)
      .then(r => {
        if (r.status >= 0) {
          if (r.msg) NotificationManager.success(r.msg, '', 4000, null, null, 'outline')
          this.toggleDelete()
          this.toggleModal()
          this.getData()
        } else NotificationManager.error(r.msg, 'Opps', 4000, null, null, 'outline')
        this.props.setLoader(false)
      })
  }

  save(item, status, typeId) {

    let data = cloneDeep(this.state.data)
    let temp = cloneDeep(this.state.dataTemp)
    if (!typeId) {
      data.map(e => {
        if (e.ID === item.ID) {
          e.processing = true
        }
        return e
      })
  
      temp.map(e => {
        if (e.ID === item.ID) {
          e.processing = true
        }
        return e
      })
    }
    
    this.setState({ data: data, dataTemp: temp })
    /*
    if (typeId && [2, -1].indexOf(item.status) < 0) {
      NotificationManager.error('La opción que ha seleccionado no se ha guardado, se guardará cuando acepete o deniegue la justificación', '', 4000, null, null, 'outline')
      return
    }
    */
    let body = status ? { status: status } : { status: item.status, typeId : typeId }

    _axios
      .post('admAttendance/0/justifications/' + item.ID, body)
      .then(r => {
        if (r.status >= 0) {
          if (!typeId) {
            data.map(e => {
              if (e.ID === item.ID) {
                e.status = status
                e.processing = false
              }
              return e
            })

            temp.map(e => {
              if (e.ID === item.ID) {
                e.status = status
                e.click = true
                e.processing = false
              }
              return e
            })
            this.setState({ data: data, dataTemp: temp })
          } 
        }
        NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
      })
      .catch((e) => { })
  }

  execute = debounce((item, status, typeId) => { this.save(item, status, typeId) }, 500, { leading: true })

  uploadFiles (id) {
    return new Promise((resolve, reject) => {
      try {

          if (!this.state.idItemSelected) return resolve('empty')

          this.props.setLoader(true)

          let setUploadActive = () => {
            if (this.state.uploadActive < 1) {
              this.setState({
                uploadActive: this.state.uploadActive + 1}, () => {
                  // console.log('cambio active', this.state.uploadActive)
                  if (this.state.uploadActive >= 1) {
                    this.props.setLoader(false)
                    return resolve('ok')
                  }
                  this.setState({
                    uploadFiles: {id: id, name: 'doc', success: setUploadActive },
                  })
                })
            }
          }

          if (1 > 0) {
            this.setState({uploadActive: 0}, () => {
              this.setState({
                uploadFiles: {id: id, name: 'doc', success: setUploadActive },
              })
            })
          }

      } catch (error) {
        reject(error)
      }
    })
  }

  defaultValuesUploadFiles () {
    this.setState({
      dropzones: [],
      uploadActive: -1,
      uploadFiles: null,
    })
  }

  listenStatesForm = (s) => {
    this.setState({ form: s });
  }

  listenStatesFormFilter = (s) => {
    this.setState({ formFilter: s });
  }

  listenBtnActionsFormFilter = (a, s, rowData) => {
    if (a === 'filter') this.getData()
  }

  filterData = () => {
    if (!this.state.formFilter) return []
    else if (this.state.formFilter.search && this.state.formFilter.search !== "") {
      return this.state.dataTemp.filter(e => {
        return e.name.toLowerCase().includes(this.state.formFilter.search.toLowerCase()) || (e.last && e.last.toLowerCase().includes(this.state.formFilter.search.toLowerCase()))
      })
    } else return this.state.dataTemp
  }

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => {
      if (!this.state.modal) this.setState({ form: defautltForm, idItemSelected: null, pupils: [], sessions: [], preview: null })
    })
  }

  toggleDelete = () => {
    this.setState(prevState => ({
      modalDelete: !prevState.modalDelete
    }), () => {
      // 
    });
  };

  formFields = () => {
    const moduleName = this.props.match.path.split('/').slice(-1)[0]
    let configFields = null
    const menuSubs = this.props.menuItems.flatMap((m) => m.subs || [])
    const foundModule = menuSubs.find((s) => s.id === moduleName)
    if (foundModule) configFields = foundModule.configFields

    let form = [
      {
        name: "ID",
        value: this.state.form.ID,
        type: "hidden",
      },
      {
        name: "name",
        value: this.state.form.name,
        type: "hidden",
      },
      {
        name: "last",
        value: this.state.form.last,
        type: "hidden",
      },
      {
        name: "last2",
        value: this.state.form.last2,
        type: "hidden",
      },
      {
        col: 6,
        name: "externalId",
        value: this.state.form.externalId,
        type: "text",
        label: "main.studentCode",
        disabled: true,
        opts: {
          style: 'float-label'
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.ID) }
      },
      {
        col: 6,
        name: "sectionTag",
        value: this.state.form.sectionTag,
        type: "text",
        label: "main.section",
        disabled: true,
        opts: {
          style: 'float-label',
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.ID) }
      },
      {
        col: 12,
        name: "attendanceTypeId",
        value: this.state.form.attendanceTypeId,
        type: "select",
        label: "main.type",
        rules: 'required',
        opts: {
          style: 'float-label',
          path: (ctx) => { return "admAttendanceType/get?pick=true" },
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.ID) }
      },
      {
        col: 6,
        name: "date",
        value: this.state.form.date,
        type: "date",
        label: "main.from",
        rules: 'required',
        opts: {
          style: 'float-label',
          selectsStart: true,
          startDate: (ctx) => ctx.state.date ? moment(ctx.state.date) : null,
          endDate: (ctx) => ctx.state.tillDate ? moment(ctx.state.tillDate) : null
        },
        disabled: () => { return this.state.idItemSelected ? true : false }
      },
      {
        col: 6,
        name: "tillDate",
        value: this.state.form.tillDate,
        type: "date",
        label: "main.to",
        parent: "date",
        opts: {
          style: 'float-label',
          selectsEnd: true,
          startDate: (ctx) => moment(ctx.state.date),
          endDate: (ctx) => moment(ctx.state.tillDate),
          minDate: (ctx) => moment(ctx.state.date)
        }
      },
      {
        col: 6,
        name: "gradeName",
        value: "",
        type: "select",
        label: "main.grade",
        rules: 'required',
        opts: {
          style: 'float-label',
          path: "/admSuperSection/get?pick=true"
        },
        renderIf: (ctx) => { return !Number.isInteger(ctx.state.ID)}
      },
      {
        col: 6,
        name: "sectionName",
        value: "",
        type: "select",
        label: "main.section",
        rules: 'required',
        parent: 'gradeName',
        opts: {
          style: 'float-label',
          path: () => { return "/admSection/get?pick=true&parentId=" + this.state.form.gradeName },
          setOutput: v => v,
        },
        renderIf: (ctx) => { return !Number.isInteger(ctx.state.ID)}
      },
      {
        col: 12,
        name: "userId",
        value: "",
        type: "select",
        label: "main.student",
        rules: 'required',
        parent: 'sectionName',
        opts: {
          style: 'float-label',
          searchOnline: true,
          withImg: true,
          path: () => { return "/admStudent/get?enrolled=1&pick=true" + (this.state.form.sectionName ? "&sectionId=" + this.state.form.sectionName.value : "") }
        },
        renderIf: (ctx) => { return !Number.isInteger(ctx.state.ID)}
      },
      {
        col: 12,
        name: "justification",
        value: this.state.form.justification,
        type: "select",
        label: `${M}justification`,
        rules: 'required',
        opts: {
          style: 'float-label',
          isClearable: true,
          items: justificationReasons
        }
      },
      {
        col: 12,
        name: "comment",
        value: this.state.form.comment,
        type: "textarea",
        label: "main.comment",
        rules: 'required',
        opts: {
          style: 'float-label',
          rows: "5"
        }
      },
      {
        col: 12,
        name: "doc",
        value: this.state.form.doc,
        type: "dropzone",
        label: `${M}attachFile`,
        rules: 'ext:jpeg,jpg,png,pdf,doc,docx',
        opts: {
          path: ()=> "admJustification/file",
          accept: '.jpeg,.jpg,.png',
          url: this.state.form.docUrl,
          output: true
        },
        onChange: (ctxForm) => {
          if (ctxForm.state.doc === null) this.setState({preview: null})
        }
      },
      {
        col: 4,
        name: "createdByName",
        value: this.state.form.createdByName,
        type: "text",
        label: "main.createdBy",
        disabled: true,
        opts: {
          style: 'float-label',
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.ID) }
      },
      {
        col: 4,
        name: "createdByEmail",
        value: this.state.form.createdByEmail,
        type: "text",
        label: (L) => `${L["main.email"]} ${L["main.contact"]}`,
        opts: {
          style: 'float-label',
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.ID) }
      },
      {
        col: 4,
        name: "createdByPhone",
        value: this.state.form.createdByPhone,
        type: "number",
        label: (L) => `${L["main.phone"]} ${L["main.contact"]}`,
        opts: {
          style: 'float-label',
        },
        renderIf: (ctx) => { return Number.isInteger(ctx.state.ID) }
      }
    ]

    form = form.map(f => ({
      ...f,
      ...(configFields?.[f.name] || {})
    })).filter(f => !f.inactive)

    return form
  }

  render() {
    const { locale } = this.props
    const L = AppLocale[locale].messages
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Row>
              <Colxx xxs="12" xxl="6">
                {/* TITLE */}
                <h1>Justificaciones</h1>
              </Colxx>
            </Row>

            {/* FILTERS */}
            <FormCustom
              id={"form-flt"}
              fields={
                [
                  {
                    name: "superSectionId",
                    value: null,
                    type: "select",
                    label: "main.grade",
                    rules: 'required',
                    opts: {
                      style: 'float-label',
                      path: "/admSuperSection/get?pick=true"
                    }
                  },
                  {
                    name: "sectionId",
                    value: "",
                    type: "select",
                    label: "main.section",
                    parent: "superSectionId",
                    rules: 'required',
                    opts: {
                      style: 'float-label',
                      path: () => { return "/admSection/get?pick=true&parentId=" + this.state.formFilter.superSectionId }
                    }
                  },
                  {
                    name: "type",
                    value: 0,
                    type: "select",
                    label: `${M}type`,
                    opts: {
                      style: 'float-label',
                      isClearable: false,
                      items: [
                        {value: 0, label: 'TODAS'},
                        {value: 1, label: 'Por horas'},
                        {value: 2, label: 'Por día'},
                        {value: 3, label: 'Por varios días'},
                      ]
                    },
                    onChange: (ctx) => {
                    }
                  },
                  {
                    name: "status",
                    value: this.state.formFilter.status,
                    type: "select",
                    label: `${M}status`,
                    opts: {
                      style: 'float-label',
                      isClearable: false,
                      items: [
                        {value: 0, label: 'TODAS'},
                        {value: 1, label: 'Pendientes'},
                        {value: 2, label: 'Aceptadas'},
                        {value: -1, label: 'Denegadas'}
                      ]
                    },
                    onChange: (ctx) => {
                      let data = cloneDeep(this.state.data)
                      data.map(e => e.click = false)
                      let pending = data.filter(e => e.status === ctx.state.status || ctx.state.status === 0)
                      this.setState({ dataTemp: pending })
                    },
                    renderIf: (ctx) => { return !ctx.state.search || ctx.state.search === "" }
                  },
                  {
                    name: "from",
                    value: this.state.formFilter.from,
                    type: "date",
                    label: "main.from",
                    opts: {
                      style: 'float-label',
                      selectsStart: true,
                      startDate: (ctx) => ctx.state.from ? moment(ctx.state.from) : null,
                      endDate: (ctx) => ctx.state.to ? moment(ctx.state.to) : null
                    }
                  },
                  {
                    name: "to",
                    value: this.state.formFilter.to,
                    type: "date",
                    label: "main.to",
                    opts: {
                      style: 'float-label',
                      selectsEnd: true,
                      startDate: (ctx) => moment(ctx.state.from),
                      endDate: (ctx) => moment(ctx.state.to),
                      minDate: (ctx) => moment(ctx.state.from)
                    }
                  },
                  {
                    name: "justification",
                    value: this.state.formFilter.justification,
                    type: "select",
                    label: "main.reason",
                    opts: {
                      style: 'float-label',
                      isClearable: true,
                      items: [{value: null, label: 'TODAS'}].concat(justificationReasons)
                    }
                  },
                  {
                    name: "search",
                    value: "",
                    type: "text",
                    label: "main.search",
                    placeholder: "main.studentFirstOrLastName",
                    opts: {
                      style: 'float-label',
                    },
                    onChange: (ctx) => {
                      let data = cloneDeep(this.state.data)
                      data.map(e => e.click = false)
                      this.setState({ dataTemp: data })
                    },
                  },
                ]
              }
              buttons = {
                [
                  {
                    label: 'main.applyFilter',
                    renderIf: (ctx) => { return ctx.state.from || ctx.state.sectionId || ctx.state.superSectionId },
                    onClick: (ctx) => { ctx.btnAction('filter') }
                  }
                ]
              }
              listenStates={this.listenStatesFormFilter}
              listenBtnActions={this.listenBtnActionsFormFilter}
            />

            <div className="mb-3 d-flex align-items-center flex-wrap">
              {/* CREATE */}
              {this.state.actions.create && 
              <Button color="primary" size="sm" className="mr-2" onClick={() => { this.toggleModal() }}>
                <i className="simple-icon-plus"></i> {L["main.create"]}
              </Button>
              }
            </div>

          </Colxx>
        </Row>

        {/* GRID */}
        <Row>
          <Colxx xxs="12">
            {this.state.progressBar && <div className="progress"><div className="indeterminate"></div></div>}
            {this.filterData() && this.filterData().length === 0 && !this.state.progressBar && <div className="fadeIn">{L["main.noRecords"]}</div>}
            {this.filterData() && this.filterData().length > 0 && 
              <div className="margin-bottom-60 card fadeIn" ref={el => (this.componentRef = el)}>
              <div className="notas" id="adm-justification">   

                <div className="notas-left">
                  <div className="notas-spacer" id="notas-header-pupil">
                    <div className="notas-title text-uppercase">{L["main.student"]}</div>
                  </div>

                  {/* Stundents */}
                  {this.filterData().map((item, i) => {
                    return (
                      <div className="notas-item" key={i.toString()}>
                        <div className="notas-face">
                          <img src={item.face ? item.face : require("../../../../assets/img/user.png")} onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/user.png")}} alt=""/>
                        </div>
                        <div className="notas-name">{item.name}</div>
                      </div>
                    )})
                  }
                </div>

                <div className="notas-right">
                  <div className="notas-header" id="notas-header">
                    <div className="notas-row">
                      <div className="notas-col">
                        <div className="notas-name">{L["main.date"] + "(S)"}</div>
                      </div>
                      <div className="notas-col">
                        <div className="notas-name">{L[`${M}justification`]}</div>
                      </div>
                      <div className="notas-col">
                        <div className="notas-name"></div>
                      </div>
                      {/*
                      <div className="notas-col">
                        <div className="notas-name">Aprobación</div>
                      </div>
                      */}
                    </div>
                  </div>

                  <div className="notas-numbers" id="notas-number">

                    {/* Stundents */}
                    {this.filterData().map((item, i) => {
                      return (
                        <div className="notas-row" key={i.toString()}>
                          <div className={"notas-col d-flex align-items-center"}>
                            <div>
                            <span className="text-capitalize font-weight-bold">{_moment(item.date).format('dddd DD MMM')}</span> <br/>
                            <span className="text-capitalize">{ item.tillDate ? ('➔ ' + _moment(item.tillDate).format('dddd DD MMM')) : '' }</span>
                            </div>
                          </div>
                          <div className={"notas-col d-flex"}>
                            <div className={"wrap-img mr-2 " + (item.click ? " opacity-25" : "")} onClick={() => { this.getDataById(item) }}>
                              <img
                                className="img-justification"
                                src={item.doc ? item.doc : require("../../../../assets/img/doc.png")} onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/doc.png")}}
                                alt=""
                              />
                            </div>
                            <Button
                              color={(item.status === 2 ? "primary" : "light")}
                              className={"cs-btn default mr-2 " + (item.click ? " opacity-25" : "")}
                              disabled={item.processing || item.status === 2}
                              onClick={() => { this.execute(item, 2) }}
                            >
                              <i className="text-one simple-icon-check"></i>
                            </Button>
                            <Button
                              color={(item.status === -1 ? "primary" : "light")}
                              className={"cs-btn default " + (item.click ? " opacity-25" : "")}
                              disabled={item.processing || item.status === -1}
                              onClick={() => { this.execute(item, -1) }}
                            >
                              <i className="text-one simple-icon-close"></i>
                            </Button>
                          </div>
                          {/*
                          <div className={"notas-col d-inline-flex"}>
                            <Field
                              col="9"
                              name={"attendance-" + i}
                              value={{ value: item.attendanceTypeId, label: item.attendanceTypeName }}
                              type="select"
                              opts= {
                                {
                                  path: (ctx) => { return "admAttendanceType/get?pick=true" },
                                }
                              }
                              onChange={(val) => {
                                if (val && val !== item.attendanceTypeId) this.save(item, null, val)
                              }}
                            />
                            <div>
                              <i className="simple-icon-pencil icon-action d-flex align-items-center" onClick={() => { this.getDataById(item) }}></i>
                            </div>
                          </div>
                          */}

                          <div className={"notas-col d-inline-flex justify-content-center"}>
                            <div>
                              <i className="simple-icon-pencil icon-action d-flex align-items-center" onClick={() => { this.getDataById(item) }}></i>
                            </div>
                          </div>
                          
                        </div>
                      )})
                    }
                  </div>
                </div>

              </div>
            </div>
            }
            
          </Colxx>
        </Row>

        <CustomModal isOpen={this.state.modal} toggle={this.toggleModal} wrapClassName={"modal-right"} size="lg">
          <ModalHeader toggle={this.toggleModal}>
            { this.state.idItemSelected ? (this.state.form.last + ' ' + this.state.form.last2 + ' ' + this.state.form.name) : 'Crear justificación' }
          </ModalHeader>
          <ModalBody>
          {this.state.form && <FormCustom
            id={"form-crud"}
            fields={this.formFields()}
            listenStates={this.listenStatesForm}
            validate={ctx => this.validateForm = ctx}
            uploadFiles={this.state.uploadFiles}
          />
          }
          {this.state.idItemSelected && this.state.form.doc && ['jpg','png','jpeg'].indexOf(getFileExtension(this.state.preview)) > -1 &&
            <img
              className="w-100 p-1 rounded-1"
              src={this.state.preview || require("../../../../assets/img/doc.png")}
              onError={(e)=>{e.target.onerror = null; e.target.src=require("../../../../assets/img/doc.png")}}
              alt=""
            />
          }
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              size="sm"
              onClick={() => { this.state.idItemSelected ? this.edit() : this.create() }}
            >
              {L["main.save"]}
            </Button>
            {this.state.idItemSelected &&
            <Button
              color="danger"
              size="sm"
              onClick={() => { this.toggleDelete() }}
            >
              {L["main.delete"]}
            </Button>
            }
            <Button outline color="secondary" size="sm" onClick={() => { this.toggleModal() }}>{L["main.cancel"]}</Button>
          </ModalFooter>
        </CustomModal>

        {/* MODAL DELETE */}
        <Dialog
          isOpen={this.state.modalDelete}
          toggle={this.toggleDelete}
          title={L['main.delete']}
          msg={L['main.msgDelete']}
          confirm={(r) => { r ? this.delete() : this.toggleDelete() }}
        ></Dialog>

      </Fragment>
    )
  }
}

const mapStateToProps = ({ settings, menu, utils, authUser }) => {
  const { menuItems } = menu;
  const { locale } = settings
  const { deepLink } = utils
  const { userAdmin } = authUser;
  return { locale, menuItems, deepLink, userAdmin };
};

export default connect(mapStateToProps, { setLoader, setDeeplink })(AdmJustification);